<template>
  <div class="financial-statement-item">
    <col-table :data="data" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="reportKind" label="报表种类">
        <template slot-scope="scope">{{
          $digitjs(reportKindMap[scope.row[formatAParams('reportKind')]]).isNull()
        }}</template>
      </col-table-column>
      <col-table-column prop="coverMonths" label="覆盖时期(月)">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('coverMonths')]).isNull() }}</template>
      </col-table-column>
      <col-table-column prop="currency" label="报表货币" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('currency')]).isNull() }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>资产</template>
      </col-table-column>
      <col-table-column prop="cashAndShortTermFunds" label="库存现金及短期资金">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashAndShortTermFunds')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('cashAndShortTermFundsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('cashAndShortTermFundsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="itemsFromOtherBanks" label="向其他银行托收中之项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('itemsFromOtherBanks')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('itemsFromOtherBanksYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('itemsFromOtherBanksYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="placingsBankAndFinInstitutions" label="定期存放银行同业及其他财务机构(资产)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('placingsBankAndFinInstitutions')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('placingsBankAndFinInstitutionsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('placingsBankAndFinInstitutionsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="tradingBills" label="商业票据">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('tradingBills')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('tradingBillsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('tradingBillsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="tradingAssets" label="交易用途资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('tradingAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('tradingAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('tradingAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonTradingAssets" label="非交易用途资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('nonTradingAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('nonTradingAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('nonTradingAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="financialAssetsAtFairValue" label="公平订值之金融资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('financialAssetsAtFairValue')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('financialAssetsAtFairValueYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('financialAssetsAtFairValueYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="availableSaleFinancialAssets" label="可供出售之证券">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('availableSaleFinancialAssets')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('availableSaleFinancialAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('availableSaleFinancialAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="derivativesAssets" label="衍生工具(资产)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('derivativesAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('derivativesAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('derivativesAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="certificatesOfDepositHeld" label="存款证">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('certificatesOfDepositHeld')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('certificatesOfDepositHeldYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('certificatesOfDepositHeldYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="loansAndAdvancesToBanks" label="银行同业贷款及垫款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('loansAndAdvancesToBanks')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('loansAndAdvancesToBanksYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('loansAndAdvancesToBanksYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="loansAndAdvancesToCustomers" label="客户贷款及垫款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('loansAndAdvancesToCustomers')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('loansAndAdvancesToCustomersYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('loansAndAdvancesToCustomersYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="financialInvestments" label="金融投资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('financialInvestments')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('financialInvestmentsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('financialInvestmentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="heldToMaturityInvestments" label="持至到期投资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('heldToMaturityInvestments')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('heldToMaturityInvestmentsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('heldToMaturityInvestmentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="InterestsEntitiesAssociates" label="联营及合资公司权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('InterestsEntitiesAssociates')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('InterestsEntitiesAssociatesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('InterestsEntitiesAssociatesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="goodwillIntangibleAssets" label="商誉及无形资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('goodwillIntangibleAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('goodwillIntangibleAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('goodwillIntangibleAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="fixedAssets" label="固定资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('fixedAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('fixedAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('fixedAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherAssets" label="其他资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalAssets" label="总资产" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>负债</template>
      </col-table-column>
      <col-table-column prop="hkdNotesInCirculation" label="香港纸币流通额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('hkdNotesInCirculation')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('hkdNotesInCirculationYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('hkdNotesInCirculationYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="deposits" label="同业及财务机构存款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('deposits')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('depositsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('depositsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="depositsFromCustomers" label="客户存款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('depositsFromCustomers')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('depositsFromCustomersYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('depositsFromCustomersYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="placementsBankAndFinInstitutions" label="定期存放银行同业及其他财务机构(负债)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('placementsBankAndFinInstitutions')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('placementsBankAndFinInstitutionsYoY')]).color() }"
              class="scale"
            >
              {{
                $digitjs(scope.row[formatAParams('placementsBankAndFinInstitutionsYoY')]).prefix().unit('%').rounded()
              }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="debtsSecuritiesIssued" label="已发行之债务证券">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('debtsSecuritiesIssued')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('debtsSecuritiesIssuedYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('debtsSecuritiesIssuedYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="certificatesOfDepositIssued" label="已发行之存款证">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('certificatesOfDepositIssued')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('certificatesOfDepositIssuedYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('certificatesOfDepositIssuedYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="convertibleBondsIssued" label="已发行之可换股债券">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('convertibleBondsIssued')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('convertibleBondsIssuedYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('convertibleBondsIssuedYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="floatingRateNotesIssued" label="已发行之浮息票据">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('floatingRateNotesIssued')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('floatingRateNotesIssuedYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('floatingRateNotesIssuedYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="tradingLiabilities" label="交易用途负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('tradingLiabilities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('tradingLiabilitiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('tradingLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="financialLiabilitiesAtFairValue" label="公平订值之金融负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('financialLiabilitiesAtFairValue')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('financialLiabilitiesAtFairValueYoY')]).color() }"
              class="scale"
            >
              {{
                $digitjs(scope.row[formatAParams('financialLiabilitiesAtFairValueYoY')]).prefix().unit('%').rounded()
              }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="derivativesLiabilities" label="衍生工具(负债)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('derivativesLiabilities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('derivativesLiabilitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('derivativesLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="subordinatedLiabilities" label="后偿负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('subordinatedLiabilities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('subordinatedLiabilitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('subordinatedLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherLiabilities" label="其他负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherLiabilities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherLiabilitiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalLiabilities" label="总负债" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalLiabilities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalLiabilitiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>股东权益</template>
      </col-table-column>
      <col-table-column prop="capitalReserve" label="资本储备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('capitalReserve')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('capitalReserveYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('capitalReserveYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherReserves" label="其他储备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherReserves')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherReservesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherReservesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalReserves" label="储备总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalReserves')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalReservesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalReservesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="ownersEquity" label="本公司拥有人应占权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('ownersEquity')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('ownersEquityYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('ownersEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonControllingInterests" label="非控股权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('nonControllingInterests')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalEquity" label="权益总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalEquity')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalEquityYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['data', 'reportKindMap', 'css', 'mainDataStyle', 'formatAParams'],
  data() {
    return {
      isSame: false,
      popupVisible: false
    }
  },
  computed: {
    pageSize() {
      return this.isSame ? 1 : 2
    }
  }
}
</script>
